/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Category_MonitorsInputs */

const he_home_category_monitors = /** @type {(inputs: Home_Category_MonitorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מסכים`)
};

const en_home_category_monitors = /** @type {(inputs: Home_Category_MonitorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monitors`)
};

/**
* | output |
* | --- |
* | "Monitors" |
*
* @param {Home_Category_MonitorsInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const home_category_monitors = /** @type {((inputs?: Home_Category_MonitorsInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Category_MonitorsInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_home_category_monitors(inputs)
	return en_home_category_monitors(inputs)
});